import React, { useEffect } from "react";
import { connect } from "react-redux";

import { fetchWatchlist } from "../actions/index";
import StockTable from "./stock-table";
import SearchBar from "./search-bar";

const Watchlist = ({ watchlist, fetchWatchlist }) => {
  useEffect(() => {
    fetchWatchlist();
  }, []);

  return (
    <>
      <SearchBar />
      <div style={{ marginTop: "24px" }}>
        <StockTable stocks={watchlist} showUpdated />
      </div>
    </>
  );
};

const mapStateToProps = ({ watchlist }) => ({ watchlist });

export default connect(mapStateToProps, { fetchWatchlist })(Watchlist);
